export default "__VITE_ASSET__BlNPsZXn__"